import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed, onMounted, nextTick, ref, useSlots } from 'vue';
var __default__ = {
    name: 'XNavBar'
};
export default /*#__PURE__*/ _defineComponent(_object_spread_props(_object_spread({}, __default__), {
    props: {
        title: String,
        fixed: Boolean,
        zIndex: [
            Number,
            String
        ],
        leftText: String,
        rightText: String,
        leftArrow: Boolean,
        placeholder: Boolean,
        safeAreaInsetTop: Boolean,
        background: {
            type: String,
            default: '#fff'
        },
        color: {
            type: String,
            default: '#333'
        },
        border: {
            type: Boolean,
            default: true
        }
    },
    emits: [
        "click-left",
        "click-right"
    ],
    setup: function(__props, param) {
        var emit = param.emit;
        var props = __props;
        var slots = useSlots();
        var hasLeft = computed(function() {
            return props.leftArrow || props.leftText || slots.left;
        });
        var hasRight = computed(function() {
            return props.rightText || slots.right;
        });
        var navBar = ref(null);
        var height = ref(0);
        onMounted(function() {
            if (props.placeholder && props.fixed) {
                nextTick(function() {
                    var _navBar_value;
                    var _navBar_value_getBoundingClientRect_height;
                    height.value = (_navBar_value_getBoundingClientRect_height = (_navBar_value = navBar.value) === null || _navBar_value === void 0 ? void 0 : _navBar_value.getBoundingClientRect().height) !== null && _navBar_value_getBoundingClientRect_height !== void 0 ? _navBar_value_getBoundingClientRect_height : 0;
                });
            }
        });
        return {
            __sfc: true,
            props: props,
            emit: emit,
            slots: slots,
            hasLeft: hasLeft,
            hasRight: hasRight,
            navBar: navBar,
            height: height
        };
    }
}));
